import Dialog from "@bmi-digital/components/dialog";
import Typography from "@bmi-digital/components/typography";
import GlobalStyles from "@mui/material/GlobalStyles";
import { modalClasses } from "@mui/material/Modal";
import { globalHistory } from "@reach/router";
import React from "react";
import { useSiteContext } from "../../../components/Site";
import { registrationMicrocopy } from "../registrationMicrocopy";
import { StyledDialog } from "./WarningDialogStyles";

export type WarningDialogProps = {
  blockedUrl: string;
  closeDialog: () => void;
};

const WarningDialog = (props: WarningDialogProps) => {
  const { getMicroCopy } = useSiteContext();

  return (
    <>
      <GlobalStyles
        styles={{
          body: {
            paddingRight: "0 !important"
          },
          [`.${modalClasses.root}`]: {
            maxWidth: "100vw !important",
            maxHeight: "100vh"
          }
        }}
      />
      <StyledDialog
        open={true}
        data-testid="warning-dialog"
        onCloseClick={props.closeDialog}
      >
        <Dialog.Title hasUnderline variant="h4">
          {getMicroCopy(registrationMicrocopy.warningTitle)}
        </Dialog.Title>
        <Dialog.Content>
          <Typography data-testid="warning-dialog-description">
            {getMicroCopy(registrationMicrocopy.warningDescription)}
          </Typography>
        </Dialog.Content>
        <Dialog.Actions
          cancelLabel={getMicroCopy(registrationMicrocopy.warningCancel)}
          confirmLabel={getMicroCopy(registrationMicrocopy.warningClose)}
          onCancelClick={props.closeDialog}
          onConfirmClick={() => globalHistory.navigate(props.blockedUrl)}
        />
      </StyledDialog>
    </>
  );
};

export default WarningDialog;
